/**
 * ROWEM collection quick add — size/option picker + Ajax add to cart
 */
(function () {
  'use strict';

  var modal;
  var modalProduct;
  var modalConfirm;
  var modalMessage;
  var optionMount;

  function parseCardProduct(card) {
    var jsonEl = card.querySelector('[data-quick-add-json]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function canQuickAdd(product) {
    return product && product.available !== false && Array.isArray(product.variants) && product.variants.length;
  }

  function optionLabel(name, values) {
    var list = values || [];
    var isPreference = list.some(function (value) {
      return /surprise|gender/i.test(String(value || ''));
    });
    if (isPreference) return 'Preference';
    if (!name) return 'Size';
    return name;
  }

  function optionDisplayValue(value) {
    if (/^gender[-\s]?neutral$/i.test(String(value || '').trim())) {
      return 'Gender-Neutral Surprise';
    }
    return value;
  }

  function showAddedFeedback(card) {
    card.querySelectorAll('.quick-add__button').forEach(function (btn) {
      var label = btn.querySelector('span') || btn;
      var original = label.getAttribute('data-quick-add-label') || label.textContent;
      label.setAttribute('data-quick-add-label', original);
      label.textContent = 'Added';
      setTimeout(function () {
        label.textContent = original;
      }, 1400);
    });
  }

  function findVariant(product, selectedOptions) {
    return product.variants.find(function (variant) {
      if (!variant.available) return false;
      return selectedOptions.every(function (value, index) {
        return variant.options[index] === value;
      });
    });
  }

  function addVariantToCart(variantId, card) {
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        if (window.RowemCart && window.RowemCart.refreshBadges) {
          return window.RowemCart.refreshBadges();
        }
      })
      .then(function () {
        if (card) showAddedFeedback(card);
      });
  }

  function ensureModal() {
    if (modal) return;

    modal = document.createElement('div');
    modal.className = 'quick-add-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="quick-add-modal__backdrop" data-quick-add-close></div>' +
      '<div class="quick-add-modal__panel" role="dialog" aria-modal="true" aria-labelledby="quick-add-modal-title">' +
        '<button type="button" class="quick-add-modal__close" data-quick-add-close aria-label="Close">&times;</button>' +
        '<h2 class="quick-add-modal__title" id="quick-add-modal-title">Select a size</h2>' +
        '<p class="quick-add-modal__product" data-quick-add-product></p>' +
        '<div data-quick-add-options></div>' +
        '<p class="product-form__message" data-quick-add-message role="status" hidden></p>' +
        '<button type="button" class="btn btn--solid btn--primary btn--large quick-add-modal__submit" data-quick-add-submit>Add to cart</button>' +
      '</div>';
    document.body.appendChild(modal);

    modal.querySelectorAll('[data-quick-add-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    modalConfirm = modal.querySelector('[data-quick-add-submit]');
    modalMessage = modal.querySelector('[data-quick-add-message]');
    optionMount = modal.querySelector('[data-quick-add-options]');

    modalConfirm.addEventListener('click', function () {
      if (!modalProduct) return;

      var selects = Array.from(optionMount.querySelectorAll('[data-quick-add-option]'));
      var selected = [];
      for (var i = 0; i < selects.length; i += 1) {
        if (!selects[i].value) {
          selects[i].focus();
          return;
        }
        selected.push(selects[i].value);
      }

      var variant = findVariant(modalProduct, selected);
      if (!variant) {
        setModalMessage('That option is unavailable.');
        return;
      }

      modalConfirm.disabled = true;
      setModalMessage('');

      var card = document.getElementById('product-' + modalProduct.id);
      addVariantToCart(variant.id, card)
        .then(function () {
          closeModal();
        })
        .catch(function (err) {
          setModalMessage((err && err.description) || 'Could not add to cart');
          modalConfirm.disabled = false;
        });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });
  }

  function setModalMessage(text) {
    if (!modalMessage) return;
    if (!text) {
      modalMessage.hidden = true;
      modalMessage.textContent = '';
      return;
    }
    modalMessage.hidden = false;
    modalMessage.textContent = text;
  }

  function escapeAttr(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function openModal(product) {
    ensureModal();
    modalProduct = product;
    modal.querySelector('[data-quick-add-product]').textContent = product.title;
    modalConfirm.disabled = false;
    modalConfirm.textContent = 'Add to cart';
    setModalMessage('');

    var options = product.options || [];
    var primaryName = optionLabel(
      options[0] && options[0].name,
      options[0] && options[0].values
    );
    modal.querySelector('.quick-add-modal__title').textContent = 'Select a ' + primaryName.toLowerCase();

    optionMount.innerHTML = options
      .map(function (option, index) {
        var label = optionLabel(option.name, option.values);
        var values = (option.values || []).filter(function (value) {
          return product.variants.some(function (variant) {
            return variant.available && variant.options[index] === value;
          });
        });
        return (
          '<label class="quick-add-modal__label" for="quick-add-option-' +
          index +
          '">' +
          escapeAttr(label) +
          '</label>' +
          '<select id="quick-add-option-' +
          index +
          '" class="quick-add-modal__select" data-quick-add-option>' +
          '<option value="">Choose a ' +
          escapeAttr(label.toLowerCase()) +
          '</option>' +
          values
            .map(function (value) {
              return (
                '<option value="' +
                escapeAttr(value) +
                '">' +
                escapeAttr(optionDisplayValue(value)) +
                '</option>'
              );
            })
            .join('') +
          '</select>'
        );
      })
      .join('');

    modal.hidden = false;
    document.body.classList.add('quick-add-modal-open');
    var firstSelect = optionMount.querySelector('[data-quick-add-option]');
    if (firstSelect) firstSelect.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modalProduct = null;
    if (modalConfirm) modalConfirm.disabled = false;
    document.body.classList.remove('quick-add-modal-open');
  }

  function handleQuickAdd(card) {
    var product = parseCardProduct(card);
    if (!canQuickAdd(product)) return;

    if (product.hasOnlyDefaultVariant) {
      var variant = product.variants.find(function (entry) {
        return entry.available;
      });
      if (!variant) return;
      addVariantToCart(variant.id, card).catch(function () {});
      return;
    }

    openModal(product);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add], .quick-add__button');
    if (!btn) return;

    var card = btn.closest('.product-item');
    if (!card || !card.querySelector('[data-quick-add-json]')) return;

    e.preventDefault();
    e.stopPropagation();
    handleQuickAdd(card);
  });
})();
